import AggregoOncology from './AggregoOncology.png';
import AlertMarketing from './AlertMarketing.jpg';
import ASCO from './ASCO.png';
import Biopharm from './Biopharm.svg';
import Connexions360 from './Connexions360.svg';
import DeepIntent from './DeepIntent.jpg';
import Doximity from './Doximity.png';
import Epocrates from './Epocrates.png';
import Healio from './HEALIO.png';
import JAMA from './JAMA.png';
import JCO from './JCO.jpg';
import Lancet from './Lancet.png';
import MDLinx from './MDLinx.jpg';
import MedPage from './Medpage.png';
import MedScape from './Medscape.svg';
import NuMedis from './NuMedis.svg';
import OBROncology from './OBROncology.png';
import ONCLive from './OncLive.png';
import OncologyLearningNetwork from './OncologyLearningNetwork.jpg';
import OptimizeRx from './OptimizeRx.png';
import PDQ from './PDQ.jpg';
import PeerDirect from './PeerDirect.svg';
import PhysiciansWeekly from './PhysiciansWeekly.jpg';
import PulsePoint from './PulsePoint.png';
import ReachMD from './REACHMD.png';
import RxNt from './RxNT.jpg';
import Sermo from './SERMO.jpg';
import StorySoft from './StorySoft.png';
import TargetOncology from './TargetedOncology.png';
import ViiHealth from './Viihealth.png';
import Vumedi from './VuMedi.png';
import VeevaSalesRep from './VeevaSalesRep.svg';
import Accc from './ACCC.png';
import NEJM from './NEJM.svg';
import NCCN from './NCCN.png';
import ASPHO from  './ASPHO.png'


export const partnersLogo = {
	'aggrego oncology' : AggregoOncology,
    'aggregooncology' : AggregoOncology,
	'alert marketing' : AlertMarketing,
    'alertmarketing' : AlertMarketing,
	'asco': ASCO,
    'biopharm': Biopharm,
	'connexions360': Connexions360,
    'connexion360': Connexions360,
	'deep intent' : DeepIntent,
    'deepintent' : DeepIntent,
    'deep_intent_programmatic' : DeepIntent,
	'doximity': Doximity,
	'epocrates' : Epocrates,
	'healio': Healio,
	'jama': JAMA,
	'jco': JCO,
	'lancet': Lancet,
    'mdlinx': MDLinx,
    'medpage': MedPage,
    'medscape': MedScape,
    'numedis': NuMedis,
    'obr oncology': OBROncology,
    'obroncology': OBROncology,
	'onclive': ONCLive,
    'oncology learning network': OncologyLearningNetwork,
    'optimize rx': OptimizeRx,
    'pdq':PDQ,
	'peer direct': PeerDirect,
    "physician's weekly": PhysiciansWeekly,
    "physician'sweekly": PhysiciansWeekly,
    "PhysicianWeekly" : PhysiciansWeekly,
    'pulse point': PulsePoint,
    'reach md': ReachMD,
    'rxnt': RxNt,
    'sermo': Sermo,
    'storysoft': StorySoft,
    'targeted oncology': TargetOncology,
    'targetedoncology': TargetOncology,
	'viihealth': ViiHealth,
    'vumedi': Vumedi,
    'veeva sales rep': VeevaSalesRep,
    'veevasalesrep': VeevaSalesRep,
    'veeva': VeevaSalesRep,
    'optimizerx' : OptimizeRx,
    'pulsepoint': PulsePoint,
    'viiv': ViiHealth,
    'peerdirect': PeerDirect,
    'reachmd': ReachMD,
    'oncologylearningnetwork': OncologyLearningNetwork,
    'targetedoncology': TargetOncology,
    'accc':Accc,
    'nejm':NEJM,
    'nccn': NCCN,
    'aspho':ASPHO

}